<template>
    <div>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="pageTitle">Layanan Pelanggan</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule">
            <div class="pt-2 pb-2 pl-3 pr-3">
                <div class="text-center mt-5 mb-5">
                    <h3 class="mb-0">Butuh Bantuan?</h3>
                    <p>Hubungi Layanan Customer Service Qiosfin</p>
                    <button class="btn btn-outline-primary btn-lg" style="height:40px;border-width:1px;" @click="$router.go(-1)">Kembali</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    mounted(){
        document.body.classList.add('bg-white')
    },
    destroyed() {
        document.body.classList.remove('bg-white')
    },
}
</script>